import { css, SerializedStyles } from '@emotion/core'

import { Color } from '../../../enums/color'

export const getFocusStyle = (error?: boolean): SerializedStyles => css`
  outline: 2px solid ${error ? Color.Red700 : Color.Lavender500};
  outline-offset: -2px;
`
